<template>
    <div>
        <div class="kgr-row">
            <h2 class="kgr-headline kgr-headline--h2">
                {{ $t('Rechnungstexte') }}
            </h2>
        </div>
        <div
            class="kgr-alert kgr-alert--info kgr-row"
        >
            {{ $t('Hier kannst du die Texte hinterlegen, die auf den Rechnungen erscheinen sollen. Die Zahlungsart kannst du bei den Rechnungsempfängern auswählen.') }}
        </div>
        <hr class="kgr-separator--light" />
        <kgr-loader v-show="loading" />
        <div
            v-show="!loading"
        >
            <kgr-form-row
                class="kgr-row"
                :error="error"
                field-name="bankTransferText"
                :label="$t('Hinweis zur SEPA-Lastschrift')"
                :tooltip="previewInvoiceText"
            >
                <input
                    v-model="invoiceTexts.sepaDebitText"
                    :placeholder="sepaDebitDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <div
                class="kgr-row"
            >
                <kgr-checkbox
                    v-model="invoiceTexts.sepaDebitAnonymizedMemberIban"
                    :label="checkboxLabelAnonymizedMemberIban"
                />
            </div>
            <div
                class="kgr-alert kgr-alert--info kgr-row"
            >
                <div class="kgr-row">
                    {{ $t('Bei Verwendung eines individuellen Hinweises stehen die Platzhalter') }}
                </div>
                <ul class="kgr-list kgr-list--bulleted">
                    <li>
                        <strong>%IBANBIC%</strong> {{ $t('(IBAN und BIC des aktuellen Standardkontos)') }}
                    </li>
                    <li>
                        <strong>%MANDATSREFERENZ%</strong> {{ $t('(Mandatsreferenz des aktuellen Standardkontos) und') }}
                    </li>
                    <li>
                        <strong>%GLÄUBIGERID%</strong> {{ $t('(Gläubiger-ID des Vereins)') }}
                    </li>
                </ul>
                {{ $t('zur Verfügung.') }}
            </div>
            <div class="kgr-row">
                <kgr-checkbox
                    v-model="invoiceTexts.sepaDebitBankAccountVisibility"
                    :label="$t('Bankverbindung der Einrichtung auf Rechnung anzeigen')"
                />
            </div>
            <hr class="kgr-separator--light" />
            <kgr-form-row
                :error="error"
                field-name="bankTransferText"
                :label="$t('Hinweis zur Überweisung')"
            >
                <input
                    v-model="invoiceTexts.bankTransferText"
                    :placeholder="sepaDebitDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <hr class="kgr-separator--light" />
            <kgr-form-row
                class="kgr-row"
                :error="error"
                field-name="cashText"
                :label="$t('Hinweis zur Barzahlung')"
            >
                <input
                    v-model="invoiceTexts.cashText"
                    :placeholder="invoiceTexts.cashDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <div
                class="kgr-row"
            >
                <kgr-checkbox
                    v-model="invoiceTexts.cashBankAccountVisibility"
                    :label="$t('Bankverbindung der Einrichtung auf Rechnung anzeigen')"
                />
            </div>
            <hr class="kgr-separator--light" />
            <kgr-form-row
                class="kgr-row"
                :error="error"
                field-name="debitCardText"
                :label="$t('Hinweis zur Kartenzahlung')"
            >
                <input
                    v-model="invoiceTexts.debitCardText"
                    :placeholder="invoiceTexts.debitCardDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <div
                class="kgr-row"
            >
                <kgr-checkbox
                    v-model="invoiceTexts.debitCardBankAccountVisibility"
                    :label="$t('Bankverbindung der Einrichtung auf Rechnung anzeigen')"
                />
            </div>
            <hr class="kgr-separator--light" />
            <kgr-form-row
                class="kgr-row"
                :error="error"
                field-name="indefiniteText"
                :label="$t('Hinweis zu Zahlungsart Undefiniert')"
            >
                <input
                    v-model="invoiceTexts.indefiniteText"
                    :placeholder="invoiceTexts.indefiniteDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <div
                class="kgr-row"
            >
                <kgr-checkbox
                    v-model="invoiceTexts.indefiniteBankAccountVisibility"
                    :label="$t('Bankverbindung der Einrichtung auf Rechnung anzeigen')"
                />
            </div>
            <hr class="kgr-separator--light" />
            <kgr-form-row
                class="kgr-row"
                :error="error"
                field-name="negativeAmountText"
                :label="$t('Hinweis bei negativen Rechnungsbeträgen')"
            >
                <input
                    v-model="invoiceTexts.negativeAmountText"
                    :placeholder="invoiceTexts.negativeAmountDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <hr class="kgr-separator--light" />
            <kgr-form-row
                class="kgr-row"
                :error="error"
                field-name="generalText"
                :label="$t('Allgemeiner Hinweis')"
            >
                <input
                    v-model="invoiceTexts.generalText"
                    :placeholder="invoiceTexts.generalDefaultText"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <hr class="kgr-separator--light" />
            <div class="kgr-row kgr-text--rightAligned">
                <button
                    class="kgr-button kgr-button--accent"
                    @click="save"
                >
                    {{ $t('save') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from '../../../components/common/form/checkbox/Checkbox.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import InvoiceTexts from '../../../js/dto/InvoiceTexts.js';
import InvoiceTextsRepository from '../../../js/repository/InvoiceTextsRepository.js';
import Loader from '../../../components/common/Loading.vue';

export default {
    components: {
        'kgr-loader': Loader,
        'kgr-checkbox': Checkbox,
        'kgr-form-row': FormRow,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            loading: false,
            error: new Error(),
            invoiceTexts: new InvoiceTexts(),
        }
    },
    computed: {
        sepaDebitDefaultText() {
            return this.invoiceTexts.sepaDebitAnonymizedMemberIban ? this.invoiceTexts.sepaDebitDefaultTextWithPlaceholders : this.invoiceTexts.sepaDebitDefaultText;
        },
        checkboxLabelAnonymizedMemberIban() {
            return this.$t('Anonymisierte Bankverbindung des Zahlers auf Rechnung anzeigen (bei individuellem Hinweis wird der Platzhalter %IBANBIC% anonymisiert).');
        },
        previewInvoiceText() {
            if(!this.invoiceTexts.sepaDebitText && !this.invoiceTexts.sepaDebitAnonymizedMemberIban) {
                return '';
            }
            let invoiceText = this.invoiceTexts.sepaDebitText || this.sepaDebitDefaultText;
            if(this.invoiceTexts.sepaDebitAnonymizedMemberIban) {
                invoiceText = invoiceText.replaceAll('%IBANBIC%', 'DE8X XXXX XXXX XXXX XX30 00, COBADEFFXXX')
            }
            InvoiceTexts.PLACEHOLDERS.forEach(placeholder => {
                invoiceText = invoiceText.replaceAll('%'+placeholder.key+'%', placeholder.example)
            });
            return 'Beispiel-Vorschau: ' + invoiceText;
        }
    },
    mounted() {
        this.loadInvoiceTexts();
    },
    methods: {
        loadInvoiceTexts() {
            this.loading = true;
            InvoiceTextsRepository.find(this.clubId)
                .then(response => this.invoiceTexts = response)
                .finally(() => this.loading = false);
        },
        save() {
            this.loading = true;
            InvoiceTextsRepository.update(this.clubId, this.invoiceTexts)
                .then(() => this.loadInvoiceTexts())
                .finally(() => this.loading = false);
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
